import { CoachingSwitchboardService } from '../../coaching-base/switchboard';
import {
    ObservationCommitDialogItem,
    ObservationCommitDialogItemStatus,
} from '../../coaching-observation/observation-commit-dialog/observation-commit-dialog.component';
import { determineCommitItems } from '../../coaching-observation/observation/determine-commit-items.function';
import { BehaviourItem } from '../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../coaching-tags/models/subbehaviour.coaching.model';

export function getDialogItems(
    formValue: any,
    isSavedObservation: boolean,
    behaviours: BehaviourItem[],
    subBehaviours: SubBehaviourItem[],
    switchboardService: CoachingSwitchboardService,
): ObservationCommitDialogItem[] {
    const items = determineCommitItems(
        formValue,
        isSavedObservation,
        behaviours,
        subBehaviours,
    );
    return items.map((e) => {
        const activeItem =
            switchboardService.pillarTwo.sbActiveCommitmentWithFocus({
                behaviourId: e.BehaviourId,
                subBehaviourId: e.SubBehaviourId,
            });
        return {
            ...e,
            Status: activeItem
                ? e.touched
                    ? ObservationCommitDialogItemStatus.UPDATED
                    : ObservationCommitDialogItemStatus.NONE
                : ObservationCommitDialogItemStatus.NEW,
            commitmentId: activeItem ? activeItem.commitmentId : null,
        };
    });
}
